const BYTES_PER_MB = 1024 * 1024;

export type UploadValidationError = 'multiple' | 'format' | 'size';

export interface UploadValidationResult {
  valid: boolean;
  error?: UploadValidationError;
  file?: File;
}

export const STANDARD_AUDIO_FORMATS = ['wav', 'mp3', 'm4a', 'wmv', 'caf', 'ogg', 'opus'];
export const COMPRESSED_AUDIO_FORMATS = ['dss', 'ds2'];

export const STANDARD_AUDIO_MAX_BYTES = 500 * BYTES_PER_MB;
export const COMPRESSED_AUDIO_MAX_BYTES = 250 * BYTES_PER_MB;

export const SUPPORTED_AUDIO_EXTENSIONS = [...STANDARD_AUDIO_FORMATS, ...COMPRESSED_AUDIO_FORMATS];

export function getFileExtension(fileName: string): string {
  const lastDot = fileName.lastIndexOf('.');
  return lastDot >= 0 ? fileName.slice(lastDot + 1).toLowerCase() : '';
}

export function getMaxSizeForExtension(extension: string): number | null {
  if (STANDARD_AUDIO_FORMATS.includes(extension)) return STANDARD_AUDIO_MAX_BYTES;
  if (COMPRESSED_AUDIO_FORMATS.includes(extension)) return COMPRESSED_AUDIO_MAX_BYTES;
  return null;
}

export function validateAudioSelection(files: FileList | File[] | null | undefined): UploadValidationResult {
  const selectedFiles = files ? Array.from(files) : [];

  if (selectedFiles.length === 0) {
    return { valid: false };
  }

  if (selectedFiles.length > 1) {
    return { valid: false, error: 'multiple' };
  }

  const file = selectedFiles[0];
  const maxSize = getMaxSizeForExtension(getFileExtension(file.name));

  if (maxSize === null) {
    return { valid: false, error: 'format', file };
  }

  if (file.size > maxSize) {
    return { valid: false, error: 'size', file };
  }

  return { valid: true, file };
}
